import React, { useState, useEffect } from 'react';
import service from './services/service'
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
export const TableList = (props) => {
    const [tables, setTables] = useState([]);
    const [selectedTable, setSelectedTable] = useState({});
    const [selectedTableType, setSelectedTableType] = useState({});
    const tableTypes = {
        tree: 1,
        customer: 2
    }
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        tableName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        companyName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        creatorUserName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        tableType: { value: null, matchMode: FilterMatchMode.EQUALS },
        isActive: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    useEffect(() => {
        window["dynamicTableApiToken"] = props.tokenKey;
        getTables();

    }, []);

    const [types] = useState(props.tableTypes.map(x => x.name));

    const [statuses] = useState(["Aktif", "Pasif"]);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const getTables = () => {

        service.get(props.apiUrl + "/CustomerTable/GetAllTable").then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }
            setTables(response.data);
        });
    }
    const setActiveTable = (rowData) => {
        const accept = () => {
            service.get(props.apiUrl + "/CustomerTable/SetActiveTable?_tableId=" + rowData.id).then(response => {
                if (response === "") {
                    return;
                }
                if (!response.success) {
                    return;
                }
                getTables();
            });
        }
        confirmDialog({
            message: `Bu işlemi onayladığınızda mevcutta aktif olan tablo pasife çekilecektir. Seçtiğiniz {${rowData.tableName}} tablosu aktif edilecektir.`,
            header: 'Uyarı',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: 'Hayır',
            acceptLabel: 'Evet',
            defaultFocus: 'accept',
            accept,

        });

    }
    const statusBodyTemplateAction = (rowData) => {
        return <Checkbox disabled={!window.Object.checkPermissions(["table_management_active_table_change"])} inputId="isActive" name="isActive" value={rowData.isActive} onChange={(e) => {
            setActiveTable(rowData);
        }} checked={rowData.isActive} />
    }
    const formatDate = (value) => {
        return value.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };
    const dateBodyTemplate = (rowData) => {
        return formatDate(new Date(rowData.insertedDate));
    };
    const processTemplate = (rowData) => {
        return <div className="card flex ">

            {window.Object.checkPermissions(["table_management_edit"]) &&
                <Button outlined icon="pi pi-pencil" tooltip="Düzenle" severity="info" onClick={(e) => {
                    setSelectedTableType(rowData.tableType);
                    if (props.onSelected) {
                        props.onSelected(rowData);

                    }
                }} raised />
            }
            {window.Object.checkPermissions(["table_management_data_list"]) &&
                <Button tooltip="Listele" outlined severity="help" icon="pi pi-list" raised onClick={(e) => {

                    if (props.onDataAdd) {
                        props.onDataAdd(rowData);
                    }
                }} />
            }
            {window.Object.checkPermissions(["table_management_remove"]) &&
                <Button tooltip="Sil (Veri kayıplarıan sebep olabilir)" outlined severity="danger" icon="pi pi-trash" raised onClick={(e) => {
                    deleteTable(rowData);

                }} />
            }


        </div>
    }
    const typeTemplate = (rowData) => {
        return props.tableTypes.find(x => x.type === rowData.tableType)?.name;
    }

    const deleteTable = (rowData) => {

        setSelectedTable(rowData);

        const reject = () => { }
        confirmDialog({
            group: 'headless',
            message: 'Bu işlem geri alınamaz!',
            header: "Tabloyu silmek üzeresiniz!",
            icon: 'pi-exclamation-circle',
            rejectLabel: 'Hayır',
            acceptLabel: 'Evet',
            defaultFocus: 'reject',
            deleteTableAction,
            reject
        });
    }
    const deleteTableAction = () => {

        if (selectedTable) {
            service.get(props.apiUrl + "/CustomerTable/DeleteTable?_tableId=" + selectedTable.id).then(response => {
                if (response === "") {
                    return;
                }
                if (!response.success) {
                    return;
                }
                setTables(tables.filter(x => x.id !== selectedTable.id));
            });
        }
    }
    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.isActive ? "Aktif" : "Pasif"} severity={rowData.isActive ? "success" : "danger"}></Tag>;
    };

    const tableTypeFilterTemplate = (options) => {
        return (
            <Dropdown value={props.tableTypes.find((x) => x.type === options.value)?.name} options={types} onChange={(e) => {

                options.filterApplyCallback(props.tableTypes.find(x => x.name === e.value)?.type)
            }} placeholder="Seçiniz" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
        );
    };

    const statusFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value != null ? (options.value === true ? "Aktif" : "Pasif") : null} options={statuses} onChange={(e) => {

                options.filterApplyCallback(e.value === "Aktif" ? true : false)
            }} placeholder="Seçiniz" className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
        );
    };
    const renderHeader = () => {
        return window.Object.checkPermissions(["table_management_add"])&&(
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-plus" label="Tablo Oluştur" onClick={props.onCreateTable} />

            </div>
        );
    };

    return (
        <div style={{ overflowY: 'auto', maxHeight: '80vh' }}>
            <ConfirmDialog />
            <ConfirmDialog
                group="headless"
                content={({ headerRef, contentRef, footerRef, hide, message }) => (
                    <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
                        <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                            <i className="pi pi-exclamation-circle text-5xl"></i>
                        </div>
                        <span className="font-bold text-2xl block mb-2 mt-4" ref={headerRef}>
                            {message.header}
                        </span>
                        <p className="font-bold text-2xl block mb-2 mt-4" style={{ color: "red" }} ref={contentRef}>
                            {message.message}

                        </p>
                        <div className="flex align-items-center gap-2 mt-4" ref={footerRef}>
                            <Button
                                label="Onayla"
                                onClick={(event) => {
                                    hide(event);
                                    deleteTableAction();
                                }}
                                className="w-8rem"
                                severity="danger"
                            ></Button>
                            <Button

                                label="İptal"

                                onClick={(event) => {
                                    hide(event);

                                }}
                                className="w-8rem"
                            ></Button>
                        </div>
                    </div>
                )}
            />

            <DataTable stripedRows header={  renderHeader} globalFilterFields={['tableType', 'isActive']} value={tables} responsiveLayout="scroll" filters={filters} filterDisplay="row">
                <Column header="" body={processTemplate} ></Column>
                <Column showFilterMenu={false} filter field="id" header="Id"></Column>
                <Column showFilterMenu={false} filter field="tableName" header="Tablo Adı"></Column>
                <Column showFilterMenu={false} filter field="companyName" header="Şirket" ></Column>
                <Column showFilterMenu={false} filter field="creatorUserName" header="Oluşturan Kullanıcı"></Column>
                <Column field="isActive" showFilterMenu={false} filter header="Durum" body={statusBodyTemplate} filterElement={statusFilterTemplate} ></Column>
                <Column field="tableType" showFilterMenu={false} filter header="Tip" body={typeTemplate} filterElement={tableTypeFilterTemplate} ></Column>
                <Column field="isActive" header="Durum Değiştir" body={statusBodyTemplateAction}></Column>
            </DataTable>


        </div>
    )

}

export default TableList;